import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as navigationActions from "../../../actions/navigationActions";
import * as rccActions from "../../../actions/rccActions";
import * as formatHelper from "../../../helpers/formatHelper";
import * as validationHelper from "../../../helpers/validationHelper";
import * as windowService from "../../../services/windowService";
import * as modelHelper from "../../../helpers/modelHelper";

import noImg from "../../../resources/img/no-image.png";
import imgPrint from "../../../resources/img/svgicons/print.svg";
import imgSave from "../../../resources/img/svgicons/save.svg";

import Button from "../generic/Button";
import CancelButton from "../generic/CancelButton";
import Modal from "../generic/Modal";

class PrintPreviewOrderModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchClosePrintModalAction();
    };

    componentDidMount = () => {
        if (this.props.activeOrder !== null) {
            this.props.dispatchGetPrintPreviewImageAction(
                this.props.templateName,
                this.props.activeOrder.formula,
                this.props.printData,
                this.props.activeOrder.formulaMoreInfo,
                this.props.activeOrder.note
            );
        }
    };

    handlePrintClick = () => {
        this.props.dispatchStartPrintReportSilentAction(
            this.props.templateName,
            this.props.activeOrder.formula,
            this.props.printData,
            this.props.activeOrder.formulaMoreInfo,
            this.props.activeOrder.note
        );
    };

    handleSaveAsButtonClick = () => {
        let printImage = window.imageStore.getPrintImageByName(this.props.templateName);

        if (printImage !== null) {
            windowService.openSaveDialog(printImage.img, formatHelper.formatFileName("IMG", printImage.type));
        }
    };

    getPrinterImage = (printImage) => {
        if (this.props.loading || printImage === null) {
            return <img alt="preview" src={noImg} />;
        }

        return <img alt={this.props.printer.name} src={"data:" + printImage.type + ";base64," + printImage.img} />;
    };

    getPrintButton = (printImage) => {
        return (
            <Button
                onClick={this.handlePrintClick}
                svgBefore={imgPrint}
                label={<Translate value="general.print" />}
                disabled={this.props.loading || printImage === null}
            />
        );
    };

    getSaveAsButton = (printImage) => {
        if (this.props.loading || windowService.isBrowser()) {
            return "";
        }

        return (
            <Button
                onClick={this.handleSaveAsButtonClick}
                svgBefore={imgSave}
                label={<Translate value="general.saveAs" />}
                disabled={printImage === null}
            />
        );
    };

    render() {
        let printImage = window.imageStore.getPrintImageByName(this.props.templateName);

        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.print" />)}
                content={modelHelper.buildModalSection(
                    <div className="padding-15 fit-image margin-left-auto margin-right-auto text-center">
                        {this.getPrinterImage(printImage)}
                    </div>
                )}
                footer={modelHelper.buildModalSection(
                    <React.Fragment>
                        {this.getPrintButton(printImage)}
                        {this.getSaveAsButton(printImage)}
                        <CancelButton onClick={this.handleCloseModalClick} />
                    </React.Fragment>,
                    "flex-gap-10px"
                )}
                styles={{
                    width: "40%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        activeOrder: store.toDispense.activeOrder,
        printData: store.toDispense.printData,
        printer: store.rcc.printer,
        templateName: validationHelper.getValidItem(store.rcc.templateList, store.settings.printerTemplate),
        imageStore: store.navigation.imageStore
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchClosePrintModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.PRINT_PREVIEW_ORDER_MODAL));
        },
        dispatchGetPrintPreviewImageAction: (template, formula, printData, moreInfoText, note) => {
            dispatch(rccActions.getPrintPreviewImage(null, template, null, formula, printData, moreInfoText, note));
        },
        dispatchStartPrintReportSilentAction: (template, formula, printData, moreInfoText, note) => {
            dispatch(
                rccActions.startPrintReportSilent(null, template, null, 1, null, formula, printData, moreInfoText, note)
            );
        }
    };
};

export default PrintPreviewOrderModal = connect(mapStoreToProps, mapDispatchToProps)(PrintPreviewOrderModal);
